import parse, { attributesToProps, domToReact } from 'html-react-parser'
import { createOnClickTrackingHandler } from '../../utils/trackingUtils'
import { Link } from '@vp/swan'
import { type MarkdownWithTrackableLinksProps } from '../../types/homepageSeo'
import type { TrackingLinkConfig } from '../../types/homepageSlimBanner'
import { useLogger } from '@vp/ubik-context'
import { SEO_ZONE_SCHEMA } from '../../utils/trackingSchemas'

export const MarkdownWithTrackableLinks: React.FC<MarkdownWithTrackableLinksProps> = ({ html, getTrackingInfo }) => {
  const logger = useLogger()
  const options = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    replace: (domNode: any) => {
      const props = attributesToProps(domNode.attribs)
      if (domNode.name === 'a' && props['href']) {
        const ctaValue = domNode.children.length > 0 && domNode.children[0].type === 'text' ? domNode.children[0].data : ''
        const trackingConfiguration = getTrackingInfo(props['href'], ctaValue) as TrackingLinkConfig
        const linkTrackingAttributes = trackingConfiguration?.linkAttributes ?? {}
        return (
          <Link
            href={props['href']}
            onClick={createOnClickTrackingHandler(trackingConfiguration, logger, SEO_ZONE_SCHEMA, props['href'])}
            {...linkTrackingAttributes}
          >
            {domToReact(domNode.children)}
          </Link>
        )
      }
    },
  }
  return html ? parse(html, options) : null
}
